import React from "react";
import { FaFilePdf, FaFileCsv, FaFileWord } from "react-icons/fa";
import {
  formatNumber,
  truncateToTwoDecimals,
} from "../../../../../../utility/helper";

const JournalComponent = ({ journalData }) => {
  return (
    <div className="p-6">
      {journalData?.data?.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {journalData?.data?.map((item) => {
            const fileUrl = item.latest_media_url || "";
            const fileExt = fileUrl.split(".").pop().toLowerCase();

            const isPdf = fileExt === "pdf";
            const isCsv = fileExt === "csv";
            const isDocx = fileExt === "docx";
            const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(
              fileExt
            );

            return (
              <div
                key={item.item_id}
                className="rounded-lg text-center dark:border-0 pb-3 w-full max-w-sm dark:shadow-none"
              >
                {fileUrl ? (
                  isPdf || isCsv || isDocx ? (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full h-40 flex flex-col items-center justify-center bg-gray-100 rounded-lg text-gray-700 hover:text-gray-900"
                    >
                      {isPdf && <FaFilePdf className="text-6xl text-red-500" />}
                      {isCsv && (
                        <FaFileCsv className="text-6xl text-green-500" />
                      )}
                      {isDocx && (
                        <FaFileWord className="text-6xl text-blue-500" />
                      )}
                      <span className="mt-2 text-sm">
                        View {fileExt.toUpperCase()}
                      </span>
                    </a>
                  ) : isImage ? (
                    <div className="w-full h-40 flex items-center justify-center bg-white dark:bg-gray-900 rounded-lg">
                      <img
                        src={fileUrl}
                        alt={item.item_name}
                        className="w-full h-40 rounded-lg bg-transparent object-fill"
                      />
                    </div>
                  ) : (
                    <div className="w-full h-40 flex items-center justify-center bg-gray-200 rounded-lg text-gray-600">
                      Unsupported File Type
                    </div>
                  )
                ) : (
                  <div className="w-full h-40 flex items-center justify-center bg-gray-200 rounded-lg text-gray-600">
                    No File
                  </div>
                )}

                <div className="flex justify-between p-6 items-center mt-2 border-b dark:border-grey/40 border-info/40 pb-1 text-lightPrimary dark:text-primary-gradient">
                  <span className="font-bold">{item.item_name}</span>
                  <span
                    className={`font-bold break-all ${
                      parseFloat(item.roi) < 0
                        ? "text-expense dark:text-warning"
                        : "text-lightPrimary dark:text-primary-gradient"
                    }`}
                  >
                    ROI{" "}
                    {formatNumber(
                      truncateToTwoDecimals(Math.abs(Number(item.roi ?? 0)))
                    )}
                    %
                  </span>
                </div>

                <div className="mt-2 px-6 flex justify-between text-lightPrimary dark:text-primary-gradient">
                  <span className="">% Luxury assets</span>
                  <span className="">
                    {item.contribution
                      ? Number(item.contribution).toFixed(2) + "%"
                      : "N/A"}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center text-gray-500 text-lg mt-10">
          No Data Available
        </div>
      )}
    </div>
  );
};

export default JournalComponent;
